import React from 'react';
import { TaskBox } from '..';
import { Page } from './styles';

export default function TaskPage({ setShowTasks }) {
  return (
    <Page>
      <TaskBox setShowTasks={setShowTasks} />
    </Page>
  );
}
